import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './../../styles/cliente/direccion.css';
import * as globals from './../../components/GlobalScripts.js';
import Sidebar_left from './Sidebar_left';
import { Link } from 'react-router-dom';

const Cliente_direccion = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);
    const [estadosCiudades, setEstadosCiudades] = useState([]);
    const [formDataAddress, setFormDataAddress] = useState({});

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);

            if (userParsed.address) {
                setFormDataAddress(userParsed.address);
            }
        }

        get_estados_ciudades();
    }, []);

    const get_estados_ciudades = () => {
        axios.post(`${path_api}/default/get_estados_ciudades.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setEstadosCiudades(response.data.estados);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los estados y ciudades",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar estados y ciudades",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const handleSubmit_address = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/update-account/address.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            address: formDataAddress,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Exito",
                    msg: "Tu cuenta se actualizo sin problemas.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataAddress(response.data.user.address);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "Tu cuenta no se ha actualizo",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la cuenta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange_address = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataAddress({ ...formDataAddress, [name]: newValue });
    };

    return (
        <>
            <div className='container-cliente page-direccion container-section'>
                <div className='left-side'>
                    <Sidebar_left />
                </div>
                <div className="right-side">
                    <form onSubmit={handleSubmit_address} className="flex-column gap-20">
                        <div className='sticky-form'>
                            <button className="button-primary" type="submit">Guardar</button>
                        </div>
                        <h2>Dirección de residencia</h2>

                        <div className="form-group">
                            <label htmlFor="direccion">Dirección</label>
                            <input
                                type="text"
                                id="direccion"
                                name="direccion"
                                value={formDataAddress.direccion}
                                onChange={handleChange_address}
                                className="input-primary"
                                placeholder="roma #123"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="referencia">Referencia</label>
                            <input
                                type="text"
                                id="referencia"
                                name="referencia"
                                value={formDataAddress.referencia}
                                onChange={handleChange_address}
                                className="input-primary"
                                placeholder=""
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="apartamento">Apartamento</label>
                            <input
                                type="text"
                                id="apartamento"
                                name="apartamento"
                                value={formDataAddress.apartamento}
                                onChange={handleChange_address}
                                className="input-primary"
                                placeholder=""
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="estado">Estado</label>
                            <select
                                id="estado"
                                name="estado"
                                value={formDataAddress.estado}
                                onChange={handleChange_address}
                                className="input-primary"
                                required
                            >
                                <option value="">Selecciona un estado</option>
                                {estadosCiudades.map((item, index) => (
                                    <option key={index} value={item.nombre}>
                                        {item.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="ciudad">Ciudad</label>
                            <select
                                id="ciudad"
                                name="ciudad"
                                value={formDataAddress.ciudad}
                                onChange={handleChange_address}
                                className="input-primary"
                                required
                            >
                                <option value="">Selecciona una ciudad</option>
                                {(() => {
                                    const selectedState = estadosCiudades.find(
                                        (item) => item.nombre === formDataAddress.estado
                                    );
                                    return selectedState && selectedState.ciudades
                                        ? selectedState.ciudades.map((ciudad) => (
                                            <option key={ciudad.id} value={ciudad.nombre}>
                                                {ciudad.nombre}
                                            </option>
                                        ))
                                        : null;
                                })()}
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="colonia">Colonia</label>
                            <input
                                type="text"
                                id="colonia"
                                name="colonia"
                                value={formDataAddress.colonia}
                                onChange={handleChange_address}
                                className="input-primary"
                                placeholder=""
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="cp">Código postal</label>
                            <input
                                type="number"
                                id="cp"
                                name="cp"
                                value={formDataAddress.cp}
                                onChange={handleChange_address}
                                className="input-primary"
                                placeholder=""
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="comentarios">Comentarios</label>
                            <textarea
                                type="text"
                                id="comentarios"
                                name="comentarios"
                                value={formDataAddress.comentarios}
                                onChange={handleChange_address}
                                className="input-primary"
                                placeholder="..."
                                rows="3"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Cliente_direccion;
